<app-layout-public>
    <div id="okta-login-container" class="splash-card-wrapper-thin"></div>
</app-layout-public>
